import { useEffect, useState } from "react";

const DashboardClock = ({ stationName }) => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = time.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true });
  const tz = time.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ').pop();
  return (
    <div className="mt-3" data-testid="dashboard-clock">
      {stationName && <p className="text-cyan-400 font-bold text-sm tracking-wide">{stationName}</p>}
      <p className="text-cyan-400 font-mono text-lg tabular-nums" data-testid="dashboard-clock-time">{fmt} {tz}</p>
    </div>
  );
};

export default DashboardClock;
